
export enum RegistrationEventType {
    REQUEST_DATA_UPDATED = "registration.requestDataUpdated",
    REQUEST_STATE_CHANGED = "registration.requestStateChanged",
}